/* eslint-disable eqeqeq */
/* eslint-disable consistent-return */
/* eslint-disable prettier/prettier */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import FormContainer from '../FormContainer/FormContainer';

const MarketoForm = ({
  server,
  munchkinId,
  assetId,
  name,
  onSubmitHandler
}) => {

  const initializeMarketo = () =>
    new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://register.fastcompany.com/js/forms2/js/forms2.min.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

  const initMunchkin = () =>
    new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = '//munchkin.marketo.net/munchkin.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

  const loadMarketoForm = () => {
    window.MktoForms2.loadForm(
      server,
      munchkinId,
      assetId,
      function (form) {
        // Add an onSuccess handler
        form.onSuccess(function () {
          if (onSubmitHandler) {
            onSubmitHandler(true);
            // Return false to prevent the submission handler
            // from taking the lead to the follow up url
            return false;
          }
        });
      }
    );
  }

  useEffect(() => {
    initializeMarketo()
      .then(loadMarketoForm)
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log('Error initializing Marketo: ', err);
      });

    initMunchkin().then(() => {
      window.Munchkin.init('610-LEE-872');
    });
  }, []);

  return (
    <div className="newsletters__page__marketo__form__container">
      {/* Form placeholder replaced by Marketo script */}
      <FormContainer id={`mktoForm_${assetId}`} name={name} />
    </div>
  );
};

MarketoForm.propTypes = {
  server: PropTypes.string,
  munchkinId: PropTypes.string,
  assetId: PropTypes.number,
  name: PropTypes.string,
  onSubmitHandler: PropTypes.func
};

MarketoForm.defaultProps = {
  server: '//register.fastcompany.com',
  munchkinId: '610-LEE-872',
  assetId: 1019,
  name: 'generic-marketo-form',
  onSubmitHandler: () => {}
};

export default MarketoForm;
